/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Tutorial_TitleInputs */

const en_fc_home_paths_tutorial_title = /** @type {(inputs: Fc_Home_Paths_Tutorial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic tutorial`)
};

/**
* | output |
* | --- |
* | "Basic tutorial" |
*
* @param {Fc_Home_Paths_Tutorial_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_tutorial_title = /** @type {((inputs?: Fc_Home_Paths_Tutorial_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Tutorial_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_tutorial_title(inputs)
});
export { fc_home_paths_tutorial_title as "fc.home.paths.tutorial.title" }